export const config = {
  documentsBffBaseUrl:
    process.env.REACT_APP_DOCUMENTS_BFF_BASEURL ||
    "https://documents-bff-dev.agyo.io",
  documentExperimentalFeature: process.env.REACT_APP_EXPERIMENTAL_FEATURES,
  digitalBoxBaseUrl:
    process.env.REACT_APP_DBOX_BASEURL ||
    "https://appdev.teamsystemdigital.com/digitalbox/#/",
  gainsightEnvKey: process.env.GAINSIGHT_ENV_KEY || "AP-45IEUH6FL6DY-2-4",
  allowAssistant:
    process.env.REACT_APP_AI_ALLOWED_IDS ||
    "abd53ac5-fcff-4744-919d-4cf94cc67327",
};
